import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

export default class extends Controller {
  static values = {
    options: { type: Object, default: {} },
  }

  connect = () => {
    flatpickr(this.element, {
      ...this.optionsValue,
      disableMobile: true, // prevent native mobile picker takeover
    })
  }
}
